import { render, staticRenderFns } from "./businessArticleDetail.vue?vue&type=template&id=5aaf2bab"
import script from "./businessArticleDetail.vue?vue&type=script&lang=js"
export * from "./businessArticleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports